import { createSelectFilter } from "./SelectFilter";

export const INDUSTRY_CHOICES = [
    { key: "hash-accessories", label: "Accessories" },
    { key: "hash-artist", label: "Artist" },
    { key: "hash-clothing", label: "Clothing" },
    { key: "hash-coffee", label: "Coffee" },
    { key: "hash-creativebuzz", label: "Creative Buzz" },
    { key: "hash-creativecommunity", label: "Creative Community" },
    { key: "hash-creatives", label: "Creatives" },
    { key: "hash-designer", label: "Designer" },
    { key: "hash-diycraft", label: "DIY Craft" },
    { key: "hash-eco-friendly", label: "Eco-friendly" },
    { key: "hash-embroidery", label: "Embroidery" },
    { key: "hash-etsy", label: "Etsy" },
    { key: "hash-events", label: "Events" },
    { key: "hash-fashion", label: "Fashion" },
    { key: "hash-florist", label: "Florist" },
    { key: "hash-food", label: "Food" },
    { key: "hash-foodpackaging", label: "Food Packaging" },
    { key: "hash-healthandbeauty-2", label: "Health and Beauty" },
    { key: "hash-homeandgift", label: "Home and Gift" },
    { key: "hash-homeware", label: "Homeware" },
    { key: "hash-hospitality", label: "Hospitality" },
    { key: "hash-illustrator", label: "Illustrator" },
    { key: "hash-kidswear", label: "Kids Wear" },
    { key: "hash-letteringandcalligraphy", label: "Lettering and Calligraphy" },
    { key: "hash-lingerie", label: "Lingerie" },
    { key: "hash-menswear", label: "Menswear" },
    { key: "hash-partner", label: "Partner" },
    { key: "hash-poshmark", label: "Poshmark" },
    { key: "hash-pottery", label: "Pottery" },
    { key: "hash-shapingtomorrow", label: "Shaping Tomorrow" },
    { key: "hash-stationery", label: "Stationery" },
    { key: "hash-swimwear", label: "Swimwear" },
];

export const IndustryFilter = createSelectFilter("Industry", INDUSTRY_CHOICES);
